"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Multimap = void 0;
/**
 * Generic multimap: a key which maps to multiple valuess.
 * The values is an array
 * -> when we query the data, we get it back in the same order
 * -> an array may contain duplicates, if same value is added multiple times
 *    (we could implement a Multiset class if we need a different kind of duplication handling)
 *
 * TODO: implement some unit tests if this is not just a test helper class.
 **/
class Multimap {
    constructor() {
        this.values = new Map();
    }
    get(key) {
        return this.values.get(key) ?? [];
    }
    has(key, value) {
        const items = this.values.get(key);
        if (items !== undefined) {
            return items.includes(value);
            // eslint-disable-next-line no-else-return
        }
        else {
            return false;
        }
    }
    add(key, value) {
        this.values.set(key, this.get(key).concat(value));
    }
    addAll(key, values) {
        this.values.set(key, this.get(key).concat(values));
    }
    remove(key, value) {
        const items = this.values.get(key);
        if (items !== undefined) {
            const newItems = items.filter((i) => i !== value);
            if (newItems.length > 0) {
                this.values.set(key, newItems);
            }
            else {
                this.values.delete(key);
            }
        }
    }
    removeAll(key, values) {
        values.forEach((value) => this.remove(key, value));
    }
    keys() {
        return Array.from(this.values.keys());
    }
}
exports.Multimap = Multimap;
//# sourceMappingURL=Multimap.js.map